import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { IMyDateModel, INgxMyDpOptions } from 'ngx-mydatepicker';
import { NoticeService, Notice } from './notice.service';
import { AppConstants, DATEPICKER, SERVER } from '../app.constants';
import { MessageService } from '../common/message.service';
import $ from 'jquery';


@Component({
    selector: 'notice',
    templateUrl: 'notice.component.html',
    providers: [NoticeService]
})
export class NoticeComponent implements OnInit, OnDestroy {

    @ViewChild(NgForm) f: NgForm;

    CONST: any = AppConstants;

    noticeDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    currentNotice: Notice;
    noticeList: Notice[];

    totalCount: number;
    currPage: number;
    PAGE_SIZE: number = AppConstants.PAGE_SIZE;  //1page 100件

    error_msg: string = "";


    constructor(
        private noticeService: NoticeService,
        private msgService: MessageService
    ) {  }


    ngOnInit() {
        this.currPage = 1;
        this.refreshPage();
    }


    getNoticeList() {
        this.noticeService.getNoticeList(this.currPage, true)
            .take(1).subscribe(
                data => {
                    this.noticeList = data['results'];
                    this.totalCount = data['count'];
                }
            );
    }


    //ページ移動 (paginationのcallback)
    pageChange(page: number) {
        this.currPage = page;
        this.getNoticeList();
    }


    noticeUpdateModalShow(execDiv: string, notice: Notice) {
        if (execDiv == this.CONST.REGIST) {
            this.clearSelectNotice();
            $('#noticeUpdateModal .modal-title').text('【 お知らせ登録 】');
        } else {
            this.noticeSelect(notice);
            $('#noticeUpdateModal .modal-title').text('【 お知らせ修正 】');
        }

        $('#noticeUpdateModal').modal('show');
    }


    noticeSelect(notice: Notice): void {
        //objectをコピー
        this.currentNotice = Object.assign({},notice);
        this.currentNotice.display_start =  { jsdate: new Date(notice.display_start), formatted: notice.display_start };
        this.currentNotice.display_end =  { jsdate: new Date(notice.display_end), formatted: notice.display_end };
    }


    //入力欄クリア
    clearSelectNotice(): void {
        let ps = new Date();
        let pe = new Date();
        pe.setDate(pe.getDate() + 7);
        this.currentNotice = new Notice();
        this.currentNotice.display_start = { jsdate: ps, formatted: ps.toLocaleDateString() };
        this.currentNotice.display_end = { jsdate: pe, formatted: pe.toLocaleDateString() };
        this.f.resetForm(this.currentNotice);
        $('#noticeUpdateModal').modal('hide');
    }


    //画面リフレッシュ
    refreshPage(): void {
        this.getNoticeList();
        this.clearSelectNotice();
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registNotice();
                break;
            case "修正":
                this.updateNotice();
                break;
            case "削除":
                this.deleteNotice();
                break;
            case "複写":
                this.registNotice();
                break;
        }
    }


    registNotice(): void {
        this.noticeService.registNotice(this.currentNotice)
        .take(1).subscribe(
            data => {
                //send websocket
                //this.noticeSocket.send(JSON.stringify({
                //    'div': AppConstants.REGIST,
                //    'notice_id': data.id
                //}));

                this.refreshPage();
            }
        );
    }


    updateNotice(): void {
        this.noticeService.updateNotice(this.currentNotice)
        .take(1).subscribe(
            data => {
                //this.noticeList.splice(this.noticeList.findIndex(({id}) => id === data.id), 1, data);
                //this.clearSelectNotice();
                this.refreshPage();
            }
        );
    }


    deleteNotice(): void {
        this.noticeService.deleteNotice(this.currentNotice.id)
        .take(1).subscribe(
            data => {
                this.refreshPage();
            }
        );
    }


    // 表示機関のチェック - ウ
    changeStartEndDisplay(type:string, event: IMyDateModel) {
        if (event) {
            // console.log('event:',event);
            if (type == "start") {
                // let old_ds = new Date(this.currentNotice.display_start.jsdate.getTime());
                // old_ds.setHours(0, 0, 0);
                // console.log('old_ds:',old_ds);
                // if (old_ds.getTime() == event.jsdate.getTime()) return;
                this.currentNotice.display_start = event;
            } else {
                // let old_de = new Date(this.currentNotice.display_end.jsdate.getTime());
                // old_de.setHours(0, 0, 0);
                // console.log('old_de:',old_de);
                // if (old_de.getTime() == event.jsdate.getTime()) return;
                this.currentNotice.display_end = event;
            }
        }

        let ds = new Date(this.currentNotice.display_start.jsdate.getTime());
        let de = this.currentNotice.display_end.jsdate;

        if (ds.getTime() > de.getTime()) {
            this.error_msg = "開始日には終了日より前の日時を入力してください。";
        } else {
            this.error_msg = "";
        }
    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/notice/notice.component.ts